import { lazyLoad } from 'site-modules/shared/components/lazy-load/lazy-load';

export const UnifiedLeadFormAsync = lazyLoad({
  loader: () => import(/* webpackChunkName: "unified-lead-form" */ './unified-lead-form'),
  componentName: 'UnifiedLeadForm',
});
